import type { ReactNode } from 'react';
import { useAppSelector } from '@/shared/store/hooks';
import { selectRoles } from '@/shared/store/slices/authSlice';
import type { UserRole } from '@/constants/roles';
import { AppErrorFallback } from '@/components/app/AppErrorFallback';

type Props = {
  roles: readonly UserRole[];
  children: ReactNode;
};

export function RequireRole({ roles, children }: Props) {
  const userRoles = useAppSelector(selectRoles);
  const allowed = roles.some((r) => userRoles.includes(r));
  return allowed ? <>{children}</> : <AppErrorFallback />;
}
